import { InputHTMLAttributes } from 'react';
import styled from 'styled-components';
import { colors } from '~/design_system/styles/colors';

export interface IInputStyled extends InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
}

export const ContainerInputStyled = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  gap: 8px;
`;

export const LabelRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const LabelError = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.3px;
  color: ${colors.red_100};
`;

export const ContentInput = styled.div`
  width: 100%;
  position: relative;
`;

export const InputStyled = styled.input<IInputStyled>`
  width: calc(100% - 24px);
  height: 40px;
  border: 1px solid ${({ error }) => (error ? colors.red_50 : colors.grey_40)};
  background: ${colors.white};
  padding: 0 12px;
  gap: 10px;
  border-radius: 4px;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: ${({ error }) => (error ? colors.red_80 : colors.grey_100)};

  :focus-visible {
    outline: none;
    border: 1px solid ${colors.aqua_60};
  }

  ::-webkit-input-placeholder {
    font-weight: 300;
    font-size: 16px;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: ${colors.grey_50};
  }

  :-ms-input-placeholder {
    font-weight: 300;
    font-size: 16px;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: ${colors.grey_50};
  }

  ::placeholder {
    font-weight: 300;
    font-size: 16px;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: ${colors.grey_50};
  }

  :disabled {
    background: ${colors.white};
  }

  :read-only {
    background: ${colors.white};
  }
`;

export const LabelStyled = styled.label`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.3px;
  color: ${colors.grey_100};
`;

export interface IPropsContainerIconStyled {
  error?: boolean;
}

export const ContainerIconStyled = styled.div<IPropsContainerIconStyled>`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
`;
